export const getIsOneTimeEmailPlaybook = playbook => (
  [
    'SEND_A_ONETIME_EMAIL',
    'MARKETING_ONE_TIME_SEQUENCE',
    'NEW_BLOG_CONTENT',
    'NEWSLETTER',
    'PRODUCT_ANNOUNCEMENT',
  ].includes(playbook.reportType)
)
